import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Problem } from './components/Problem';
import { FailedSolutions } from './components/FailedSolutions';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { Audience } from './components/Audience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-[#0B1029] text-slate-50 selection:bg-[#F5D0A9]/30 selection:text-white font-sans overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <Hook data-id="element-2" />
      <Problem data-id="element-3" />
      <FailedSolutions data-id="element-4" />
      <Mechanism data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <Audience data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Proof data-id="element-9" />
      <FAQ data-id="element-10" />
      <Offer data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}